import Features from "shared/src/uidispatcherapi/Features";
import { FeatureSessionStore } from "shared/src/uidispatcherapi/FeatureSessionStore";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";

export function shouldShowSubcategoriesPanelOnCategoryPages(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_SUBCATEGORIES_PANEL) === "B";
}

export function shouldShowSubcategoriesPanelOnSearchPages(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_SUBCATEGORIES_PANEL_SEARCHPAGE) === "B";
}

export function articleSourcesFeatureActive(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.ARTICLE_SOURCES_FACET) === "B";
}

export function useExternalNavigationWebComponent(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_USE_EXTERNAL_NAVIGATION) === "B";
}

export function isXForYFeatureActive(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_X_FOR_Y) === "B";
}

export function isBulkPricesFeatureActive(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_BULK_PRICES) === "B";
}

export function isShowCSatSurveyActive(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_SHOW_ARTICLLESEARCH_CSAT) === "B";
}

export function suggestionsDebug(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SUGGESTIONS_DEBUG) === "B";
}

export function fsdFilterAlwaysActiveForStoreDeliveryCustomers(): boolean {
    return (
        FeatureSessionStore.getMembershipFor(Features.SD_FSD_FILTER_ALWAYS_ACTIVE_FOR_STORE_DELIVERY_CUSTOMERS) === "B"
    );
}

export function dontShowInfoSuggestions(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_NO_INFO_SUGGESTIONS) === "B";
}

export function showMetroXStoreSelectorFSD(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_SHOW_METRO_X_STORE_SELECTOR_FSD) === "B";
}

export function showMetroXStoreSelectorCCOV(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_SHOW_METRO_X_STORE_SELECTOR_CCOV) === "B";
}

export function showEVAlternativesComponentDebugToggle(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_FOR_DEBUG_ONLY_SHOW_EV_ALTERNATIVES_COMPONENT) === "B";
}

export function alwaysShowAlternatives(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.CA_SHOW_ALTERNATIVES_ALWAYS) === "B";
}

export function useMetroXAccountFlyout(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.CA_USE_METROX_ACCOUNT_FLYOUT) === "B";
}

export function isSearchDebugEnabled(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SEARCH_DEBUG) === "B";
}

export function isMetroX(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.METRO_X) === "B";
}

export function isFixedContentWidth(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.ENABLE_FIXED_WIDTH_CONTENT) === "B";
}

export function useNewDesign(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.CIA_NEW_CREATE_LISTS_BUTTON) === "B";
}

export function isSuggestContentEnabled(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_SUGGEST_CONTENT) === "B";
}

export function isAnonCartEnabled(): boolean {
    return !!CountryUtil.getOcCountryConfig()?.anonCart;
}

export function isNewFooterEnabled(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.CI_NEW_FOOTER) === "B";
}

export function isNewAccountFlyoutFallbackEnabled(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.CIA_NEW_ACCOUNT_FLYOUT_FALLBACK) === "B";
}

export function isNewCustomerPortalEnabled(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.CIA_NEW_CUSTOMER_PORTAL) === "B";
}

export function isNewCustomerPortalNotificationEnabled(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.CIA_NEW_CUSTOMER_PORTAL_MENU_CHANGE_NOTIFICATION) === "B";
}

export function isShowAddToCartButtonInsideSuggestionsActive(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_SHOW_ADD_TO_CART_IN_SUGGESTIONS) === "B";
}
